import React, { useEffect, useState } from "react";
import "./App.css";
import logo from "./assets/logo.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AnimeCarousel from "./AnimeCarousel";
import { fetchAnimeByGenre } from "./assets/service";

function App() {
  const [mangaAnime, setMangaAnime] = useState([]);
  const [romcomAnime, setRomcomAnime] = useState([]);
  const [modernArtAnime, setModernArtAnime] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setMangaAnime(await fetchAnimeByGenre(1));       // Manga (Action genre)
      setRomcomAnime(await fetchAnimeByGenre(22));     // Romcom (Romance genre)
      setModernArtAnime(await fetchAnimeByGenre(36));  // Modern Art (Avant-Garde genre)
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div className="App">
      {/* Navbar */}
      <nav className="navbar">
  <img src={logo} alt="Website Logo" className="logo" />

  {/* Burger Icon */}
  <div className="burger" onClick={() => setMenuOpen(!menuOpen)}>
    <span></span>
    <span></span>
    <span></span>
  </div>

  {/* Links */}
  <div className={`nav-links ${menuOpen ? "active" : ""}`}>
    <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
    <a href="#manga" onClick={() => setMenuOpen(false)}>Manga</a>
    <a href="#romcom" onClick={() => setMenuOpen(false)}>Romcom</a>
    <a href="#modernart" onClick={() => setMenuOpen(false)}>Modern Art</a>
    <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
  </div>
</nav>

      {/* Sections */}
      <div id="home" className="section home-section">
        <video autoPlay loop muted className="background-video">
          <source src="/bg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="home-content">
          <h1>Welcome to MangaMixer!</h1>
          <p>
            Discover a curated collection of anime stickers across various genres,
            including Manga, Romcom, and Modern Art. Dive into each section to find
            stickers that capture the essence of your favorite styles.
          </p>
          <p>Explore and download unique stickers to personalize your collection!</p>
          <div className="construction-banner">
            🚧 This website is under construction. Stay tuned for updates! 🚧
          </div>
        </div>
      </div>

      <div id="manga" className="section">
        <video autoPlay loop muted className="background-video">
          <source src="/manga.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <h2>Manga</h2>
        <p>Explore stunning Manga-themed stickers here!</p>
        {loading ? <p>Loading...</p> : <AnimeCarousel animeList={mangaAnime} />}
      </div>

      <div id="romcom" className="section">
        <video autoPlay loop muted className="background-video">
          <source src="/romcom.mp4" type="video/mp4" />
          
          Your browser does not support the video tag.
        </video>
        <h2>Romcom</h2>
        <p>Find the best romantic-comedy stickers here!</p>
        {loading ? <p>Loading...</p> : <AnimeCarousel animeList={romcomAnime} />}
      </div>

      <div id="modernart" className="section">
        <video autoPlay loop muted className="background-video">
          <source src="/modernshi.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <h2>Modern Art</h2>
        <p>Dive into the world of modern art with these stickers!</p>
        {loading ? <p>Loading...</p> : <AnimeCarousel animeList={modernArtAnime} />}
      </div>

      <div id="about" className="section">
        <h2>About</h2>
        <p>
          MangaMixer is your ultimate destination for finding and sharing anime
          stickers across genres. Made with ❤️ for anime enthusiasts.
        </p>
      </div>

      {/* Footer */}
      <footer>
        <p>
          &copy; 2024 MangaMixer. Made with ❤️ by OM. <a href="#home">Back to Top</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
